import React from 'react';
import CancellationsContainer from '../../components/modules/Reports/Cancellations/CancellationsContainer';

const Cancellations = () => {
  return <CancellationsContainer />;
};

export default Cancellations;
